import { useEffect } from "react";
import { useDebouncedState } from "../../utilities/hooks/useDebouncedState";

export const useDebouncedInputHandle = ({ value, onChange }) => {
  const [inputValue, debouncedInputValue, setInputValue] =
    useDebouncedState(value);

  useEffect(() => {
    onChange(debouncedInputValue);
  }, [debouncedInputValue]);

  useEffect(() => {
    if (value !== debouncedInputValue) {
      setInputValue(value);
    }
  }, [value]);

  return {
    inputValue,
    setInputValue,
  };
};
